export function setCookie(name: string, value: string, days = 365) {
    if (typeof document === 'undefined') return
    let expires = ''
    if (days) {
        const date = new Date()
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
        expires = `; expires=${date.toUTCString()}`
    }
    document.cookie = `${name}=${value}${expires}; path=/`
}

export function getCookie(name: string) {
    if (typeof document !== 'undefined') {
        if (document.cookie) {
            var nameEQ = name + '='
            var ca = document.cookie.split(';')
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i]
                while (c.charAt(0) == ' ') c = c.substring(1, c.length)
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
            }
            return ''
        } else {
            return ''
        }
    }
}

export function extractEmailFromUserIdCookie(userid: string): string | undefined {
    if (!userid) return undefined
    try {
        const decoded = decodeURIComponent(userid)
        const email = decoded.split('|')[0]
        return email
    } catch {
        return undefined
    }
}

export function deleteCookie(name: string, domain?: string) {
    document.cookie = `${name}=; Max-Age=0; path=/;` + (domain ? ` domain=${domain};` : '')
    document.cookie = `${name}=; Max-Age=0; path=${window.location.pathname};` + (domain ? ` domain=${domain};` : '')
}
export const path = (p, o) => {
    const reducerFunction = (xs, x) => {
        return xs && xs[x] ? xs[x] : null
    }
    return p.reduce(reducerFunction, o)
}
export const isServer = () => {
    return typeof window === 'undefined' || !window
}
export const pollForIosCallback = (timeout = 4000, interval = 500) => {
    return new Promise((resolve, reject) => {
        const startTime = Date.now()

        const checkCallback = () => {
            if (typeof window?.webkit?.messageHandlers['FLIGHTS_HOME'] == 'object') {
                resolve('SUCCESS')
            } else if (Date.now() - startTime > timeout) {
                resolve('TIMEOUT')
            } else {
                setTimeout(checkCallback, interval)
            }
        }

        checkCallback()
    })
}
export const checkDeviceType = () => {
    let deviceType = null
    if (isServer()) {
        return deviceType
    }
    const userAgent = path(['navigator', 'userAgent'], window)?.toLowerCase()
    const safari = /safari/.test(userAgent) // checks if browser is safari
    const ios = /iphone|ipod|ipad/.test(userAgent) // checks if device is among iphone, ipad or ipod

    if (path(['androidData', 'app-agent'], window) && path(['androidData', 'js-version'], window)) {
        return 'AndroidApp'
    }
    if (
        (path(['iosData', 'app-agent'], window) && path(['iosData', 'js-version'], window)) ||
        (ios && !safari) // checks if device is of ios but not running in safari browser
    ) {
        return 'iPhoneApp'
    }
    if (path(['sessionStorage'], window) && typeof window.sessionStorage != 'undefined') {
        return sessionStorage.getItem('mobileApp')
    }
    return deviceType
}

export const htmlSanitizer = (value: any) => {
    if (typeof value !== 'string') return value
    var re = /(<([^>]+)>)/gi
    if (value?.match(re)) {
        return ''
    } else {
        return value
    }
}
